// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"bonusgame","826":"index"}[chunkId] || chunkId) + "." + {"245":"ff174","272":"3985b","826":"fdbf1"}[chunkId] + ".js";
};